import styled from 'styled-components';

export const StepLoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;

  h2 {
    color: #2863d0;
  }
`;
